import React from "react";
import PropTypes from "prop-types";

import { translate as t } from "../../../../infrastructure/translate/localization";
import "./benefitGiftCard.scss";

const BenefitGiftCard = ({ disabled, loading, image, handlerEnabled }) => {
  if (loading) {
    return (
      <div className="gift-card-container loading">
        <p>{t("common-messages.loading-data")}</p>
      </div>
    );
  }
  return (
    <div className="gift-card-container">
      <img src={image} alt="icon" />
      <button
        type="button"
        className={disabled ? "disabled" : undefined}
        onClick={handlerEnabled}
      >
        {disabled ? t("actions.active") : t("actions.deactivate")}
      </button>
    </div>
  );
};

BenefitGiftCard.defaultProps = {
  loading: false,
  disabled: false,
  image: undefined,
  handlerEnabled: () => {},
};

BenefitGiftCard.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  image: PropTypes.string,
  handlerEnabled: PropTypes.func,
};

export default BenefitGiftCard;
